import { render, staticRenderFns } from "./OutOfOfficeForm.vue?vue&type=template&id=48bca7b6&scoped=true"
import script from "./OutOfOfficeForm.vue?vue&type=script&lang=js"
export * from "./OutOfOfficeForm.vue?vue&type=script&lang=js"
import style0 from "./OutOfOfficeForm.vue?vue&type=style&index=0&id=48bca7b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bca7b6",
  null
  
)

export default component.exports